<template>
    <VModalWrapper :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <ValidationProvider class="active-form__field" name="name" rules="required|max:191" v-slot="{ errors }">
                    <label class="active-form__label active-form__label_required" for="dictionary-name">
                        Название справочника
                    </label>

                    <VInput
                        id="dictionary-name"
                        name="name"
                        class="active-form__control"
                        :class="{ error: errors[0] }"
                        placeholder="Например: Отделы"
                        v-model="dictionary.name"
                    />

                    <span class="active-form__error">{{ errors[0] }}</span>
                </ValidationProvider>

                <div class="dictionary-card__values">
                    <label class="active-form__label active-form__label_required">Значения</label>

                    <div v-for="(option, i) in dictionary.options" :key="i" class="dictionary-card__value">
                        <ValidationProvider
                            class="active-form__field dictionary-card__value-field"
                            :vid="`value-${i}`"
                            name="Значение"
                            rules="required|max:191"
                            v-slot="{ errors }"
                        >
                            <VInput
                                class="active-form__control"
                                :class="{ error: errors[0] }"
                                placeholder="Значение"
                                :value="option"
                                @input="(value) => onOptionInput(i, value)"
                            />
                            <span class="active-form__error">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <VButton
                            v-if="dictionary.options.length > 1"
                            type="button"
                            class="button_orange button_small dictionary-card__value-remove"
                            title="Удалить значение"
                            @click="removeOption(i)"
                        >
                            ×
                        </VButton>
                    </div>

                    <VButton type="button" class="button_green-light button_small" @click="addOption">
                        Добавить значение
                    </VButton>
                </div>

                <div class="active-form__actions">
                    <VButton type="button" class="active-form__action button_green-light" @click="hide">
                        Отмена
                    </VButton>

                    <VButton type="submit" class="active-form__action button_green">Сохранить</VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
import VInput from '../components/VInput/VInput.vue';
import VButton from '../components/VButton/VButton.vue';
import VModalWrapper from '../components/VModalWrapper/VModalWrapper.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../js/enums/ModalNames';
import ModalMixin from '../../js/vue/mixins/ModalMixin';

@Component({
    components: {
        VInput,
        VButton,
        VModalWrapper,
        ValidationObserver,
        ValidationProvider,
    },
})
class VAdminDictionaryCard extends ModalMixin {
    @Prop({ type: String, default: ModalNames.ADMIN_PANEL_DICTIONARY_CARD })
    name;
    @Prop({ type: String, default: 'Справочник' })
    defaultTitle;

    dictionary = { id: null, name: '', options: [''] };

    onOptionInput(index, value) {
        // Direct index assignment is not reactive in Vue 2, so go through $set.
        this.$set(this.dictionary.options, index, value);
    }

    addOption() {
        this.dictionary.options.push('');
    }

    removeOption(index) {
        // Keep at least one row so the dictionary can never be emptied to zero fields in the UI.
        if (this.dictionary.options.length <= 1) {
            return;
        }

        this.dictionary.options.splice(index, 1);
    }

    submit() {
        this.resolve({
            id: this.dictionary.id ?? null,
            name: this.dictionary.name,
            // Trim here too so a value that is only whitespace is caught by the row's `required` rule
            // before it ever reaches the server.
            options: this.dictionary.options.map((option) => (option || '').trim()),
        });

        this.hide();
    }

    /**
     * Clones the passed dictionary into local state — editing must not mutate the page's row object,
     * so cancelling leaves the list untouched — and guarantees at least one editable value row.
     */
    beforeOpen(event) {
        const source = event?.params?.dictionary ?? {};
        const options = Array.isArray(source.options) && source.options.length ? [...source.options] : [''];

        this.dictionary = {
            id: source.id ?? null,
            name: source.name ?? '',
            options,
        };
    }

    beforeClose() {
        this.dictionary = { id: null, name: '', options: [''] };
    }
}

export default VAdminDictionaryCard;
</script>
<style lang="scss">
.dictionary-card {
    &__values {
        margin-bottom: 12px;
    }

    &__value {
        display: flex;
        align-items: flex-start;
        gap: 8px;
    }

    &__value-field {
        flex: 1 1 0;
        min-width: 0;
        margin-bottom: 8px !important;
    }

    &__value-remove.button {
        flex: 0 0 auto;
        width: auto;
        margin-top: 4px;
    }
}
</style>
